<ng-container *ngrxLet="systemCondition$; let systemCondition">
    <fieldset [formGroup]="systemConditionGroup">
        @if (systemCondition.measurementXmlId) {
            <fieldset class="radios" [formGroup]="measurementsRadioGroup">
                <div class="row mb-3">
                    <div class="col">
                        <span class="options">
                            <pace-forms-input-radio
                                [label]="systemCondition.initialMeasurementLabel"
                                [value]="MEASUREMENT_SELECTION.INITIAL_MEASUREMENT"
                                [name]="systemCondition.measurementXmlId"
                                [formControl]="measurementsFormControl"
                            ></pace-forms-input-radio>
                        </span>
                    </div>
                    <div class="col">
                        <span class="options">
                            <pace-forms-input-radio
                                [label]="systemCondition.repeatMeasurementLabel"
                                [value]="MEASUREMENT_SELECTION.REPEAT_MEASUREMENT"
                                [name]="systemCondition.measurementXmlId"
                                [formControl]="measurementsFormControl"
                            ></pace-forms-input-radio>
                        </span>
                    </div>
                </div>
                <hr />
            </fieldset>
        }
        @if (isAstoriaForm$ | async; as isAstoriaForm) {
            <fieldset class="radios" [formGroup]="systemConditionRadios">
                <div class="row mb-3">
                    <div class="col">
                        <span class="options">
                            <fieldset [disabled]="disableNoDeficiencies$ | async">
                                <pace-forms-input-radio
                                    [label]="systemCondition.noDeficienciesLabel"
                                    [value]="DEFICIENCY_SELECTION.NO_DEFICIENCIES"
                                    [formControl]="deficienciesRadio"
                                    [name]="systemCondition.deficienciesXmlId"
                                ></pace-forms-input-radio>
                            </fieldset>
                        </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="options">
                            <pace-forms-input-radio
                                [label]="systemCondition.slightDeficienciesLabel"
                                [value]="DEFICIENCY_SELECTION.SLIGHT_DEFICIENCIES"
                                [name]="systemCondition.deficienciesXmlId"
                                [formControl]="deficienciesRadio"
                            ></pace-forms-input-radio>
                        </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="options">
                            <pace-forms-input-radio
                                [label]="systemCondition.seriousDeficienciesLabel"
                                [value]="DEFICIENCY_SELECTION.SERIOUS_DEFICIENCIES"
                                [name]="systemCondition.deficienciesXmlId"
                                [formControl]="deficienciesRadio"
                            ></pace-forms-input-radio>
                        </span>
                    </div>
                </div>
            </fieldset>
        } @else {
            <fieldset class="radios">
                @if (systemCondition.choices.choicePositive; as choice) {
                    <div class="row mb-3">
                        <div class="col">
                            <fieldset [disabled]="disableNoDeficiencies$ | async">
                                <pace-forms-input-radio
                                    [label]="choice.label"
                                    [value]="choice.xmlId"
                                    [formControl]="deficienciesRadio"
                                ></pace-forms-input-radio>
                            </fieldset>
                        </div>
                    </div>
                }
                @if (systemCondition.choices.choiceNegative; as choice) {
                    <div class="row mb-3">
                        <div class="col">
                            <pace-forms-input-radio
                                [label]="choice.label"
                                [value]="choice.xmlId"
                                [formControl]="deficienciesRadio"
                            ></pace-forms-input-radio>
                        </div>
                    </div>
                }
                @if (systemCondition.choices.choiceNa; as choice) {
                    <div class="row mb-3">
                        <div class="col">
                            <pace-forms-input-radio
                                [label]="choice.label"
                                [value]="choice.xmlId"
                                [formControl]="deficienciesRadio"
                            ></pace-forms-input-radio>
                        </div>
                    </div>
                }
            </fieldset>
        }
        @if (systemCondition.imagingRemark.length > 0) {
            <div class="row mb-3">
                <div class="col">
                    <p>{{ systemCondition.imagingRemark }}</p>
                </div>
            </div>
        }
        @if (systemCondition.remarksXmlId.length > 0) {
            <div class="row mb-3">
                <div class="col">
                    <label class="col-form-label" for="{{ systemCondition.remarksXmlId }}">{{
                        systemCondition.remarksLabel
                    }}</label>
                    <textarea
                        class="col form-control input-md text-input"
                        id="{{ systemCondition.remarksXmlId }}"
                        cols="100"
                        rows="4"
                        formControlName="remarksTextarea"
                    ></textarea>
                </div>
            </div>
        }
        <div class="row mb-3">
            <div class="col">
                <pace-forms-system-condition-signature
                    [signature$]="systemConditionEmployeeSignature$"
                    formControlName="employeeSignature"
                ></pace-forms-system-condition-signature>
            </div>
        </div>
        @if (systemCondition?.customerSignature) {
            <div class="row mb-3">
                <div class="col">
                    <pace-forms-system-condition-signature
                        [signature$]="systemConditionCustomerSignature$"
                        formControlName="customerSignature"
                    ></pace-forms-system-condition-signature>
                </div>
            </div>
        }
    </fieldset>
</ng-container>
